import { IStudentLogDetailRequest, IStudentLogItemRequest } from '../../../models/request/y-te/studentLogRequests';
import { IStudentLogSelectRequest } from '../../../models/request/y-te/yTeRequests';
import { StudentLogItemResponse } from '../../../models/response/y-te/studentlog';

export enum eStudentLogActionTypeIds {
	LOAD_START = "STUDENT_LOG_LOAD_START",
	LOAD_SUCCESS = "STUDENT_LOG_LOAD_SUCCESS",
	LOAD_ERROR = "STUDENT_LOG_LOAD_ERROR",

	LOAD_DETAIL_START = "STUDENT_LOG_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "STUDENT_LOG_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "STUDENT_LOG_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "STUDENT_LOG_SHOW_DETAIL",
	CLOSE_DETAIL = "STUDENT_LOG_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "STUDENT_LOG_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "STUDENT_LOG_SHOW_CONFIRM",
	CLOSE_CONFIRM = "STUDENT_LOG_CLOSE_CONFIRM",

	SAVE_START = "STUDENT_LOG_SAVE_START",
	SAVE_SUCCESS = "STUDENT_LOG_SAVE_SUCCESS",
	SAVE_ERROR = "STUDENT_LOG_SAVE_ERROR",

	DELETE_START = "STUDENT_LOG_DELETE_START",
	DELETE_SUCCESS = "STUDENT_LOG_DELETE_SUCCESS",
	DELETE_ERROR = "STUDENT_LOG_DELETE_ERROR"
}

export interface IStudentLogLoadStart {
	type: eStudentLogActionTypeIds.LOAD_START,
	payload: IStudentLogSelectRequest
}
export interface IStudentLogLoadSuccess {
	type: eStudentLogActionTypeIds.LOAD_SUCCESS,
	payload: StudentLogItemResponse[]
}
export interface IStudentLogLoadErr {
	type: eStudentLogActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IStudentLogLoadDetailStart {
	type: eStudentLogActionTypeIds.LOAD_DETAIL_START,
	payload: IStudentLogDetailRequest
}
export interface IStudentLogLoadDetailSuccess {
	type: eStudentLogActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: StudentLogItemResponse
}
export interface IStudentLogLoadDetailErr {
	type: eStudentLogActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IStudentLogShowDetail {
	type: eStudentLogActionTypeIds.SHOW_DETAIL,
	payload?: StudentLogItemResponse
}
export interface IStudentLogCloseDetail {
	type: eStudentLogActionTypeIds.CLOSE_DETAIL
}
export interface IStudentLogChangeSelectedIds {
	type: eStudentLogActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IStudentLogShowConfirm {
	type: eStudentLogActionTypeIds.SHOW_CONFIRM
}
export interface IStudentLogCloseConfirm {
	type: eStudentLogActionTypeIds.CLOSE_CONFIRM
}
export interface IStudentLogSaveStart {
	type: eStudentLogActionTypeIds.SAVE_START,
	payload: IStudentLogItemRequest
}
export interface IStudentLogSaveSuccess {
	type: eStudentLogActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IStudentLogSaveErr {
	type: eStudentLogActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IStudentLogDeleteStart {
	type: eStudentLogActionTypeIds.DELETE_START,
	payload: number
}
export interface IStudentLogDeleteSuccess {
	type: eStudentLogActionTypeIds.DELETE_SUCCESS
}
export interface IStudentLogDeleteErr {
	type: eStudentLogActionTypeIds.DELETE_ERROR,
	payload: string
}

export type IStudentLogActionTypes = IStudentLogLoadStart | IStudentLogLoadSuccess | IStudentLogLoadErr |
	IStudentLogLoadDetailStart | IStudentLogLoadDetailSuccess | IStudentLogLoadDetailErr |
	IStudentLogShowDetail | IStudentLogCloseDetail |
	IStudentLogChangeSelectedIds |
	IStudentLogShowConfirm | IStudentLogCloseConfirm |
	IStudentLogSaveStart | IStudentLogSaveSuccess | IStudentLogSaveErr |
	IStudentLogDeleteStart | IStudentLogDeleteSuccess | IStudentLogDeleteErr
